/* global FWP */

const Search = () => {
  const $body = $('body')
  const $search_container = $body.find('[data-role="search-container"]')
  const $facet_results = $body.find('[data-role="facetwp-results"]')
  const $no_results = $body.find('[data-role="no-result"]')

  if ($search_container.length) {
    $(document).on('facetwp-loaded', () => {
      const search_term = FWP.facets.search_bar || FWP.facets.toolbox_search
      const search_number = FWP.settings.pager.total_rows
      $facet_results.html(search_number)

      if (parseInt(search_number) < 1) {
        $no_results.removeClass('hidden')
      } else {
        $no_results.addClass('hidden')
      }

      window.dataLayer.push({
        'event': 'page_load',
        'section' : 'Rechercher',
        'sub_section' : 'Rechercher',
        'search_term' : search_term.toString(),
        'search_number' : search_number,
        'template_name' : 'recherche',
      })
    })
  }

  $('[data-search-button]').on('click', function() {
    const collapse = $(this).closest('[data-search]');

    collapse.find('[data-search-input]').val('');
  })
}

export default Search;



// WEBPACK FOOTER //
// ./scripts/components/Search.js